import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { Hero } from '../components/portfolio/Hero';
import { Marquee } from '../components/portfolio/Marquee';
import { ExperienceTimeline } from '../components/portfolio/ExperienceTimeline';
import { Capabilities } from '../components/portfolio/Capabilities';
import { EarlierAndFooter } from '../components/portfolio/EarlierAndFooter';
/** Interactive, scroll-animated portfolio surface (body only). */
export function PortfolioView({
  onViewCv
}: {
  onViewCv?: () => void;
}) {
  const {
    scrollYProgress
  } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    mass: 0.4
  });
  return <main className="pf-root relative min-h-screen w-full overflow-x-hidden" data-id="element-346" data-mp="2qh2pi9v8t048">
      {/* scroll progress bar */}
      <motion.div style={{
      scaleX: progress
    }} className="fixed inset-x-0 top-0 z-50 h-[3px] origin-left bg-[var(--accent)]" aria-hidden="true" data-id="element-347" data-mp="2chkx7kiqn4q4" />

      <Hero data-id="element-348" data-mp="2ooe252rbfyeg" />
      <Marquee data-id="element-349" data-mp="2oo48n572b940" />
      <ExperienceTimeline data-id="element-350" data-mp="2onktfw8sqyto" />
      <Capabilities data-id="element-351" data-mp="2or0b96tuulys" />
      <EarlierAndFooter onViewCv={onViewCv} data-id="element-352" data-mp="2knu3tvv0aoqq" />
    </main>;
}